/**
 * The trial count for each of the profile's two trial sections.
 *
 * `clinicalTrialsCount` counts the expert's own trials and
 * `institutionalTrialsCount` the trials listed at their institution, which the
 * server derives and does not include in the first. An API that predates the
 * split omits `institutionalTrialsCount`, which reads as no institutional
 * trials.
 *
 * @param user - The profile payload, or nothing while it loads
 * @returns The count for each section
 */
export function profileTrialCounts(
  user:
    | { clinicalTrialsCount?: number | null; institutionalTrialsCount?: number | null }
    | null
    | undefined
): { own: number; institutional: number } {
  return {
    own: user?.clinicalTrialsCount ?? 0,
    institutional: user?.institutionalTrialsCount ?? 0,
  };
}

/**
 * The number the profile's "Clinical Trials" chip shows, which is the number of trials the
 * profile lists: the expert's own, plus their institution's while the institutional_trials
 * flag is on.
 *
 * @param user - The profile payload, or nothing while it loads
 * @param institutionalEnabled - Whether the institutional_trials flag is on
 */
export function shownTrialCount(
  user: Parameters<typeof profileTrialCounts>[0],
  institutionalEnabled: boolean
): number {
  const { own, institutional } = profileTrialCounts(user);

  return own + (institutionalEnabled ? institutional : 0);
}
